import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const GraphBarSvg = ({ width, height, color }: Props) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.54545 10.9091H0.909091C0.667985 10.9091 0.436754 11.0049 0.266267 11.1754C0.0957789 11.3458 0 11.5771 0 11.8182V19.0909C0 19.332 0.0957789 19.5632 0.266267 19.7337C0.436754 19.9042 0.667985 20 0.909091 20H4.54545C4.78656 20 5.01779 19.9042 5.18828 19.7337C5.35877 19.5632 5.45455 19.332 5.45455 19.0909V11.8182C5.45455 11.5771 5.35877 11.3458 5.18828 11.1754C5.01779 11.0049 4.78656 10.9091 4.54545 10.9091ZM3.63636 18.1818H1.81818V12.7273H3.63636V18.1818ZM19.0909 7.27273H15.4545C15.2134 7.27273 14.9822 7.36851 14.8117 7.53899C14.6412 7.70948 14.5455 7.94071 14.5455 8.18182V19.0909C14.5455 19.332 14.6412 19.5632 14.8117 19.7337C14.9822 19.9042 15.2134 20 15.4545 20H19.0909C19.332 20 19.5632 19.9042 19.7337 19.7337C19.9042 19.5632 20 19.332 20 19.0909V8.18182C20 7.94071 19.9042 7.70948 19.7337 7.53899C19.5632 7.36851 19.332 7.27273 19.0909 7.27273ZM18.1818 18.1818H16.3636V9.09091H18.1818V18.1818ZM11.8182 0H8.18182C7.94071 0 7.70948 0.0957789 7.53899 0.266267C7.36851 0.436754 7.27273 0.667985 7.27273 0.909091V19.0909C7.27273 19.332 7.36851 19.5632 7.53899 19.7337C7.70948 19.9042 7.94071 20 8.18182 20H11.8182C12.0593 20 12.2905 19.9042 12.461 19.7337C12.6315 19.5632 12.7273 19.332 12.7273 19.0909V0.909091C12.7273 0.667985 12.6315 0.436754 12.461 0.266267C12.2905 0.0957789 12.0593 0 11.8182 0ZM10.9091 18.1818H9.09091V1.81818H10.9091V18.1818Z"
      fill={color}
    />
  </svg>
)

GraphBarSvg.defaultProps = {
  width: 20,
  height: 20,
  color: colors.Primary.GreyText
}

export default GraphBarSvg
